import { Pipe, PipeTransform } from '@angular/core';
import { CenterDepartment } from 'src/app/shared/models/center-department';
import { Employee } from 'src/app/shared/models/employee/employee';

@Pipe({
	name: 'filterEmployeeByDepartment'
})
export class FilterEmployeeByDepartmentPipe implements PipeTransform {
	transform(
		employees: Employee[],
		centerDepartments: CenterDepartment[]
	): Employee[] {
		if (
			employees === null ||
			!employees ||
			(Array.isArray(employees) && employees.length === 0) ||
			centerDepartments === null ||
			(Array.isArray(centerDepartments) && centerDepartments.length === 0)
		) {
			return employees;
		}

		return employees.filter((employee) => {
			return employee.centerDepartments.some((spe) =>
				centerDepartments
					.map((spec) => spec.name)
					.some((specStr) => specStr.includes(spe.name))
			);
		});
	}
}
